import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { DespreMine } from './pages/DespreMine';
import { Contact } from './pages/Contact';
import { Testimoniale } from './pages/Testimoniale';
import { Magazin } from './pages/Magazin';
import { OfferRoute } from './pages/OfferRoute';
import { PACKAGE_ORDER } from './data/packages';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-1" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/despremine" element={<DespreMine data-id="element-9" />} data-id="element-8" />
            <Route path="/contact" element={<Contact data-id="element-11" />} data-id="element-10" />
            <Route path="/testimoniale" element={<Testimoniale data-id="element-13" />} data-id="element-12" />
            <Route path="/magazin" element={<Magazin data-id="element-15" />} data-id="element-14" />
            {PACKAGE_ORDER.map(slug => <Route key={slug} path={`/${slug}`} element={<OfferRoute slug={slug} data-id="element-17" />} data-id="element-16" />)}
            <Route path="*" element={<HomePage data-id="element-19" />} data-id="element-18" />
          </Routes>
        </main>
        <Footer data-id="element-20" />
      </div>
    </BrowserRouter>;
}